import React, { PureComponent } from "react";
//import PropTypes from "prop-types";
import styles from "./Comment.local.scss";
import classnames from "classnames";

import AuthorsComponent from "../../Community/NewCommunity/Authors/AuthorsComponent";

export default class Comment extends PureComponent {
  // static propTypes = {
  //   media: PropTypes.object.isRequired,
  //   size: PropTypes.oneOf(["sm", "lg"]),
  //   onClickSettings: PropTypes.func,
  //   onClickView: PropTypes.func,
  //   onClickSelect: PropTypes.func
  // };

  render() {
    const { type } = this.props;
    let { comment, user } = this.props.comment;

    return (
      <div
        className={classnames(
          styles.comment__entity,
          type === "TOPIC" ? styles.topic_comment_entity : ""
        )}
      >
        <div className={styles.comment__infos}>
          {user ? (
            <AuthorsComponent
              authors={[{ ...user, enableAvatar: true }]}
              fromComment={true}
            />
          ) : null}
        </div>
        <p className={styles.comment__text}>{comment}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Reveal/Comments/Comment.js